import { Box, Typography, useTheme } from "@mui/material";
import { tokens } from "../theme";

const Header = ({ title, subtitle, sx = {} }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box mb="24px">
      <Typography
        variant="h2"
        fontWeight="bold"
        sx={{
          color: "#6e0506",
          mb: subtitle ? "6px" : 0,
          ...sx,
        }}
      >
        {title}
      </Typography>
      {subtitle ? (
        <Typography
          variant="h5"
          sx={{
            color: colors.grey[400],
          }}
        >
          {subtitle}
        </Typography>
      ) : null}
    </Box>
  );
};

export default Header;
